import moment from 'moment';

export const getOrdinalSuffix = (number) => {
  const j = number % 10;
  const k = number % 100;

  if (j === 1 && k !== 11) {
    return "st";
  }
  if (j === 2 && k !== 12) {
    return "nd";
  }
  if (j === 3 && k !== 13) {
    return "rd";
  }
  return "th";
}



const expirationDate = (frequency, unit) => {
  const currentDate = moment();
  return currentDate.add(frequency, unit).format('DD MMM YYYY');
};

function capitalizeFirstLetter(string) {
  return string.charAt(0).toUpperCase() + string.slice(1);
}

export function getFormattedExpirationDate(selectedPlan, checkBoxChecked, suggestedPlan, productPlan) {
  const capitalize = (str) => str?.toLowerCase().replace(/^\w/, c => c.toUpperCase());

  if (productPlan?.recurring && selectedPlan && !checkBoxChecked) {
    return expirationDate(
      productPlan.totalSubscriptionPeriod ?? 0,
      capitalize(productPlan.frequencyUnit)
    );
  } else if (checkBoxChecked && suggestedPlan && !suggestedPlan.recurring) {
    return expirationDate(
      suggestedPlan.totalSubscriptionPeriod ?? 0,
      capitalize(suggestedPlan.frequencyUnit)
    );
  } else if (checkBoxChecked && suggestedPlan) {
    return expirationDate(
      suggestedPlan.totalSubscriptionPeriod ?? 0,
      capitalize(suggestedPlan.frequencyUnit)
    );
  } else if (selectedPlan) {
    return expirationDate(
      selectedPlan.totalSubscriptionPeriod ?? 0,
      capitalize(selectedPlan.frequencyUnit)
    );
  } else {
    return '';
  }
}

